import type {NextPage} from 'next'
import {useEffect, useState} from "react";
import Router, {useRouter} from 'next/router'
import {LayoutUser} from "components/Layout";
import styles from "styles/user.module.scss";
import {Button, Carousel, Col, Container, Form, FormControl, Row} from "react-bootstrap";
import {CardEbookList} from "components/Card";
import InputGroup from "react-bootstrap/InputGroup";
import {AiOutlineSearch} from "react-icons/ai";
import {useEbookFeed, useEbookFeedSubject, useEbookFeedTitle, useSubject, useUser} from "../queries";
// import {useEbookList} from "queries";


const Home: NextPage = () => {
    const {user} = useUser({redirectTo: '/login'})
    const [ebookFeed, setEbookFeed] = useState([]);
    const router = useRouter()
    const {title, subject} = router.query
    const ebookData = useEbookFeed(0)

    const ebookDataTitle = useEbookFeedTitle(0, `${title ?? ''}`)
    const ebookDataSubject = useEbookFeedSubject(0, `${subject ?? ''}`)

    const subjectData = useSubject();
    const optionSubject = subjectData?.data?.map(val => {
        return {label: val.name, value: val.name}
    }) ?? [];

    const eb = ebookData?.data?.content ?? [];
    const ebTitle = ebookDataTitle?.data?.content ?? [];
    const ebSubject = ebookDataSubject?.data?.content ?? [];

    useEffect(() => {
        if (title) {
            setEbookFeed(ebookDataTitle?.data?.content ?? []);
        } else if (subject) {
            setEbookFeed(ebookDataSubject?.data?.content ?? []);
        } else {
            setEbookFeed(ebookData?.data?.content ?? []);
        }
    }, [title, subject, eb, ebTitle, ebSubject])

    if (!user) {
        return <div></div>
    }

    return (
        <LayoutUser title="Dashboard" navItem="Dashboard" header={true}>
            <Container fluid className={styles.noPadding}>
                <Row>
                    <Col>
                        <Carousel>
                            <Carousel.Item interval={1000}>
                                <img
                                    className={`d-block w-100 ${styles.imageCarousel}`}
                                    src="/images/banner/Artboard 2.jpg"
                                    alt="First slide"
                                />
                            </Carousel.Item>
                            <Carousel.Item interval={500}>
                                <img
                                    className={`d-block w-100 ${styles.imageCarousel}`}
                                    src="/images/banner/Artboard 2_1.jpg"
                                    alt="Second slide"
                                />
                            </Carousel.Item>
                            <Carousel.Item>
                                <img
                                    className={`d-block w-100 ${styles.imageCarousel}`}
                                    src="/images/banner/Artboard 2_2.jpg"
                                    alt="Third slide"
                                />
                            </Carousel.Item>
                        </Carousel>
                    </Col>
                </Row>
            </Container>
            <br/>
            <br/>
            <Container>
                <Row>
                    <Col lg={3}>
                        <InputGroup className="mb-3">
                            <Button className={styles.buttonAddon} id="button-addon1">
                                <AiOutlineSearch/>
                            </Button>
                            <FormControl
                                aria-label="Example text with button addon"
                                aria-describedby="basic-addon1"
                                placeholder="Search"
                                value={title ?? ''}
                                onChange={(e) => {
                                    if (e.target.value.length < 1) {
                                        Router.push({
                                                pathname: '/',
                                            },
                                            undefined, {shallow: true}
                                        )
                                    } else {
                                        Router.push({
                                                pathname: '/',
                                                query: {title: e.target.value}
                                            },
                                            undefined, {shallow: true}
                                        )
                                    }
                                }}
                                className={styles.inputAddon}
                            />
                        </InputGroup>
                    </Col>
                    <Col lg={3}>
                        <Form.Group controlId="exampleForm.ControlInput1">
                            <Form.Select value={subject ?? ''} onChange={(e) => {
                                if (e.target.value.length < 1) {
                                    Router.push({
                                            pathname: '/',
                                        },
                                        undefined, {shallow: true}
                                    )
                                } else {
                                    Router.push({
                                            pathname: '/',
                                            query: {subject: e.target.value}
                                        },
                                        undefined, {shallow: true}
                                    )
                                }
                            }} aria-label="--Pilih--">
                                <option value={''}>All Subjek</option>
                                {optionSubject.map(val => {
                                    return (<option key={val.value} value={val.value}>{val.label}</option>)
                                })}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col className="text-center">
                        <h1 className={styles.title}>Kontent Perpustakaan</h1>
                    </Col>
                </Row>
                <Row>
                    <CardEbookList data={ebookFeed}/>
                </Row>
            </Container>
        </LayoutUser>
    )
}

export default Home
